import { GlobalToken, Drawer } from 'antd';
import styled from 'styled-components';
import { breakpoints } from '@/utils/util-breakpoints';
import { CustomThemeToken } from '@/theme';

export const AssetAssignmentSection = styled.div<{ theme: { token: GlobalToken } }>`
  width: 100%;
  max-width: 62.625rem;
  padding: 24px;
  margin-left: 0;
  background: ${({ theme }) => theme.token.colorBgContainer};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: flex-start;

  @media (max-width: ${breakpoints.lg}px) {
    max-width: 100%;
  }

  @media (max-width: ${breakpoints.md}px) {
    padding: 16px;
  }

  .add-room-button {
    color: ${({ theme }) => theme?.token?.colorPrimary};
    border-color: ${({ theme }) => theme?.token?.colorPrimary};
  }

  .section-header {
    height: 40px;
    display: flex;
    align-items: flex-start;
    gap: 32px;
  }

  .section-title {
    flex: 1;
    color: ${({ theme }) => theme.token.colorPrimaryText};
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
  }
`;

export const CompressorSelectDrawer = styled(Drawer)<{ theme: { token: CustomThemeToken } }>`
  /* Override drawer content height with higher specificity */
  && .ant-drawer-content-wrapper {
    height: 50%;
    max-height: 50vh;
  }

  .ant-drawer-content {
    background-color: ${({ theme: { token } }) => token.colorBgContainer};
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .ant-drawer-header {
    background-color: ${({ theme: { token } }) => token.colorBgContainer};
    color: ${({ theme: { token } }) => token.colorText};
    border-bottom: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
    padding: 16px;
  }

  .ant-drawer-title {
    color: ${({ theme: { token } }) => token.colorText};
    font-size: 18px;
    font-weight: 600;
    text-align: left;
  }

  .ant-drawer-body {
    background-color: ${({ theme: { token } }) => token.colorBgContainer};
    padding: 24px 24px 80px 24px; /* Increased bottom padding for footer */
    position: relative;
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .ant-drawer-wrapper-body {
    background-color: ${({ theme: { token } }) => token.colorBgContainer};
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
  }

  .drawer-content {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .compressor-list {
    flex: 1;
    overflow-y: auto;
    padding: 0;
    margin-bottom: 8px;
    /* Hide scrollbar for Chrome, Safari and Opera */
    &::-webkit-scrollbar {
      display: none;
    }
    /* Hide scrollbar for IE, Edge and Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }

  .compressor-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    cursor: pointer;
    border-bottom: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
  }

  .compressor-item.selected {
    background-color: ${({ theme: { token } }) => token.colorPrimaryBg};
  }

  .compressor-item:last-child {
    border-bottom: none;
  }

  .compressor-item:hover {
    background-color: ${({ theme: { token } }) => token.colorFillTertiary};
  }

  .compressor-item-checkbox {
    margin-right: 12px;
  }

  .compressor-item-text {
    color: ${({ theme: { token } }) => token.colorText};
    font-size: 16px;
    flex: 1;
  }

  .selected-icon {
    color: ${({ theme: { token } }) => token.colorPrimary};
    font-size: 18px;
  }

  .drawer-footer {
    padding: 16px;
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: ${({ theme: { token } }) => token.colorBgContainer};
    border-top: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
    z-index: 10;
    box-shadow: 0px -2px 8px ${({ theme: { token } }) => token.colorShadow || token.colorFillQuaternary};
  }

  .ant-btn-primary {
    width: 80%;
    height: 40px;
    font-size: 16px;
    border-radius: 8px;
  }

  /* Increase specificity for the drawer z-index */
  &&.compressor-select-drawer {
    z-index: 1050;
  }

  @media (max-width: ${breakpoints.md}px) {
    /* Use double ampersand to increase specificity */
    && .ant-drawer-content,
    && .ant-drawer-wrapper-body,
    && .ant-drawer-body,
    && .ant-drawer-header {
      background-color: ${({ theme: { token } }) => token.colorBgContainer};
    }

    .drawer-content {
      background-color: ${({ theme: { token } }) => token.colorBgContainer};
    }

    .compressor-item {
      background-color: ${({ theme: { token } }) => token.colorBgContainer};
    }
  }
`;
